// src/pages/logistica/OcupacionAlmacen.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

function hoyISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export default function OcupacionAlmacen() {
  const [almacen, setAlmacen] = useState('PT');
  const [fecha, setFecha] = useState(hoyISO());
  const [config, setConfig] = useState({ PT: null, MP: null });
  const [ocupadas, setOcupadas] = useState('');
  const [historico, setHistorico] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    api.get('/api/logistica/ocupacion/config').then((res) => {
      const mapa = { PT: null, MP: null };
      res.data.data.forEach((r) => { mapa[r.almacen] = r.total_localidades; });
      setConfig(mapa);
    }).catch((err) => console.error(err));
  }, []);

  useEffect(() => { cargarDia(); cargarHistorico(); }, [almacen, fecha]); // eslint-disable-line

  async function cargarDia() {
    try {
      setCargando(true);
      const res = await api.get('/api/logistica/ocupacion/captura', { params: { almacen, fecha } });
      setOcupadas(res.data.data ? String(res.data.data.localidades_ocupadas) : '');
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  async function cargarHistorico() {
    try {
      const res = await api.get('/api/logistica/ocupacion/historico', { params: { almacen, dias: 14 } });
      setHistorico(res.data.data);
    } catch (err) {
      console.error(err);
    }
  }

  async function handleGuardar() {
    if (ocupadas === '') {
      setMensaje({ tipo: 'error', texto: 'Captura cuántas localidades están ocupadas.' });
      return;
    }
    try {
      setGuardando(true);
      setMensaje(null);
      const res = await api.post('/api/logistica/ocupacion/captura', { almacen, fecha, localidades_ocupadas: parseInt(ocupadas) });
      setMensaje({ tipo: 'ok', texto: `✓ Guardado — ${res.data.pct_ocupacion}% de ocupación.` });
      cargarHistorico();
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'No se pudo guardar.' });
    } finally {
      setGuardando(false);
    }
  }

  const total = config[almacen];
  const pctPreview = total && ocupadas !== '' ? Math.round((parseInt(ocupadas) / total) * 1000) / 10 : null;
  const colorPreview = pctPreview === null ? '#8A7690' : pctPreview >= 90 ? '#B23A48' : pctPreview >= 75 ? '#B8862E' : '#3E7C5A';

  return (
  <div style={styles.contenedor} className="contenedor-captura">
      <h1 style={styles.titulo}>Ocupación del Almacén</h1>
      <p style={styles.subtitulo}>Captura diaria de localidades ocupadas — Coordinador de Almacén.</p>

      <div style={styles.controles}>
        <label style={styles.label}>
          Almacén
          <select value={almacen} onChange={(e) => setAlmacen(e.target.value)} style={styles.input}>
            <option value="PT">Producto Terminado</option>
            <option value="MP">Materia Prima / Empaque</option>
          </select>
        </label>
        <label style={styles.label}>
          Fecha
          <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} style={styles.input} />
        </label>
      </div>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        {cargando ? (
          <p>Cargando...</p>
        ) : (
          <>
            <div style={styles.filaCaptura} className="fila-flex">
              <div>
                <div style={styles.label2}>Localidades ocupadas</div>
                <input
                  type="number"
                  min="0"
                  max={total || undefined}
                  value={ocupadas}
                  onChange={(e) => setOcupadas(e.target.value)}
                  style={styles.inputGrande}
                />
                <span style={styles.deTexto}>de {total ?? '—'} totales</span>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={styles.label2}>% Ocupación</div>
                <div style={{ ...styles.pctPreview, color: colorPreview }}>{pctPreview !== null ? `${pctPreview}%` : '—'}</div>
              </div>
            </div>
            <button onClick={handleGuardar} disabled={guardando} style={styles.botonGuardar}>
              {guardando ? 'Guardando...' : 'Guardar captura del día'}
            </button>
          </>
        )}
      </div>

      {historico.length > 0 && (
        <div style={styles.tarjeta}>
          <h2 style={styles.tituloHistorico}>Últimos 14 días — {almacen}</h2>
          <div style={styles.historicoTabla}>
            {historico.map((h) => (
              <div key={h.fecha} style={styles.historicoFila}>
                <span style={styles.historicoFecha}>{new Date(h.fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short' })}</span>
                <div style={styles.barraFondo}>
                  <div style={{ ...styles.barraLlena, width: `${h.pct_ocupacion}%`, background: h.pct_ocupacion >= 90 ? '#B23A48' : h.pct_ocupacion >= 75 ? '#D6A644' : '#3E7C5A' }} />
                </div>
                <span style={styles.historicoPct}>{h.pct_ocupacion}%</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '640px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  controles: { display: 'flex', gap: '18px', marginBottom: '16px' },
  label: { display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '11px', color: '#8A7690', fontWeight: 600, textTransform: 'uppercase' },
  label2: { fontSize: '11px', color: '#8A7690', fontWeight: 600, textTransform: 'uppercase', marginBottom: '6px' },
  input: { padding: '8px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7', minWidth: '170px' },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', marginBottom: '16px' },
  filaCaptura: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '16px' },
  inputGrande: { width: '100px', padding: '8px 10px', fontSize: '22px', fontWeight: 700, border: '1px solid #D6A644', borderRadius: '8px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  deTexto: { fontSize: '11px', color: '#8A7690', marginLeft: '8px' },
  pctPreview: { fontSize: '26px', fontWeight: 700 },
  botonGuardar: { width: '100%', padding: '10px', fontSize: '13px', fontWeight: 600, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  tituloHistorico: { fontSize: '13px', fontWeight: 700, color: '#2A1830', marginBottom: '12px' },
  historicoTabla: { display: 'flex', flexDirection: 'column', gap: '6px' },
  historicoFila: { display: 'flex', alignItems: 'center', gap: '10px' },
  historicoFecha: { fontSize: '11px', color: '#8A7690', width: '50px', flexShrink: 0 },
  barraFondo: { flex: 1, height: '10px', background: '#F0E9E0', borderRadius: '6px', overflow: 'hidden' },
  barraLlena: { height: '100%', borderRadius: '6px' },
  historicoPct: { fontSize: '11px', fontWeight: 700, width: '40px', textAlign: 'right' },
};